export const formFieldCss = ({ base = 'form-field', customClass, overrideCss, isInvalid, }) => {
    const blockClassName = [base];
    const labelClassName = [`${base}__label`];
    const inputClassName = [`${base}__field`];
    const validationClassName = [`${base}__validation`];
    if (!overrideCss) {
        blockClassName.push(base);
        labelClassName.push(`${base}__label`);
        inputClassName.push(`${base}__field`);
        validationClassName.push(`${base}__validation`);
    }
    if (customClass) {
        blockClassName.push(customClass);
        labelClassName.push(`${customClass}__label`);
        inputClassName.push(`${customClass}__field`);
        validationClassName.push(`${customClass}__validation`);
    }
    if (isInvalid) {
        if (!overrideCss) {
            inputClassName.push(`${base}__field--invalid`);
        }
        if (customClass) {
            inputClassName.push(`${customClass}__field--invalid`);
        }
    }
    return {
        blockClassName: blockClassName.join(' '),
        labelClassName: labelClassName.join(' '),
        inputClassName: inputClassName.join(' '),
        validationClassName: validationClassName.join(' '),
    };
};
//# sourceMappingURL=formFieldCss.js.map